/**
 * 文档地址
 * https://it.yingzhongshare.com/astro-pivot/article/381-735#%E4%B8%89%E3%80%81SDK%E5%88%9D%E5%A7%8B%E5%8C%96
 */

import { PollingError, PollResult } from "@/utils/QuickTaskPoller";

enum Environment {
    production = 'production', // 生产环境
    development = 'development', // 开发环境
    gray = 'gray', // 灰度环境
    pre = 'pre', // 预发布环境
    daily = 'daily', // 日发布环境
    local = 'local', // 本地环境
    test = 'test', // 测试环境
    others = 'others' // 其他环境
}

// import.meta.env.VITE_ENV !== Environment.development
const isDev = import.meta.env.VITE_ENV == Environment.development || import.meta.env.VITE_ENV == Environment.test;


/**
 * 产品ID
 */
export const PRD_ID = '2210103';

/**
 * 当前渠道
 */
export const CURRENT_CHANNEL = '123';

/**
 * 业务版本名
 */
export const APP_VERSION = '1.0.0';


/**
 * 业务版本号
 */
export const APP_VERSION_CODE = 100;


/**
 * 是否测试环境，默认正式，上线必须传false
 */
export const IS_TEST = isDev;


/**
 * 是否debug模式，为true则会有sdk的log信息
 * sdk的相关请求不会加密，默认否，上线必须传false
 */
export const IS_DEBUG = isDev;


/**
 * 订单状态--0:支付中 1:支付成功 2:支付失败 -1:订单不存在

 */
export const ORDER_STATUS = {
    PAYING: 0,
    SUCCESS: 1,
    FAILED: 2,
    NOT_EXIST: -1
};

/**
 * 增加检查订单状态的函数
 */
/**
 * 检查订单状态
 * @param result 订单结果
 * @returns PollResult 轮询结果
 */
export const checkOrderStatus = (result: { data: { status: number } }): PollResult => {
    switch (result.data.status) {
        case ORDER_STATUS.SUCCESS:
            return PollResult.COMPLETE;
        case ORDER_STATUS.FAILED:
        case ORDER_STATUS.NOT_EXIST:
            return PollResult.CANCEL;
        case ORDER_STATUS.PAYING:
            return PollResult.CONTINUE;
        default:
            throw new PollingError('未知订单状态');
    }
};
